module.exports = __webpack_public_path__ + "static/media/25-8.acbbbd5d.mp3";